function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.8784 8.81767C29.755 8.93917 29.593 9 29.4312 9C29.2698 9 29.1085 8.93964 28.9851 8.81876C28.7382 8.57669 28.7377 8.18379 28.984 7.9411L31.846 5.12068L0.753651 5.12069C0.404861 5.12069 0.12207 4.84278 0.12207 4.5C0.12207 4.15722 0.404861 3.87931 0.753651 3.87931L31.846 3.8793L28.984 1.05904C28.7377 0.816345 28.7382 0.423292 28.9851 0.181223C29.2321 -0.0608465 29.632 -0.060381 29.8784 0.182464L33.8152 4.06178C34.061 4.30401 34.061 4.69597 33.8152 4.93835L29.8784 8.81767Z",
  fill: "#111111"
});

const SvgArrowThinRight = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 34,
  height: 9,
  viewBox: "0 0 34 9",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrowThinRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-thin-right.2c2da708.svg";
export { ForwardRef as ReactComponent };